import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LetDirective } from '@ngrx/component';

import { AvatarModule } from '@lockton-apps/shared/ui/lui';
import { GetPipe } from '@lockton-apps/shared/util/ng-lodash';

import { DynamicTableColumnTemplate } from '../column-template.directive';
import { MatTooltipModule } from '@angular/material/tooltip';

interface ClaimsCellProps {
  path: string;
  predicate: (value: unknown) => boolean;
}

@Component({
  selector: 'la-claims-cell',
  imports: [
    CommonModule,
    AvatarModule,
    MatIconModule,
    LetDirective,
    GetPipe,
    MatTooltipModule,
  ],
  templateUrl: './claims-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClaimsCellComponent extends DynamicTableColumnTemplate<ClaimsCellProps> {}
